// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Box, Group, LoadingOverlay, Skeleton, Stack, Text } from '@mantine/core';
import { FC, useState } from 'react';
import { i18n } from '@lingui/core';
import { useListState } from '@mantine/hooks';
import { AnswerDto, QuestionDto } from '../../Types/QuestionnaireT';
import { QuestionBundleS } from '../../Service/QuestionBundleS';
import LinkText from '../../Atoms/LinkText';
import EmptyText from '../../Atoms/EmptyText';
import { ThemeText } from '../../Atoms/ThemeText';
import { Language } from '../../Types/DocumentT';
import AnswerOptionItem from './AnswerOptionItem';

interface Props {
  question: QuestionDto;
  language: Language;
}

const QuestionAnswers: FC<Props> = ({ question, language }) => {
  const { id: questionId, answer: initialAnswers, additionalAnswer: initialAdditionaAnswer } = question;
  const [answers, handlers] = useListState<AnswerDto>(initialAnswers);
  const [additionalAnswer, setAdditionalAnswer] = useState(initialAdditionaAnswer);
  const [inserting, setInserting] = useState(false);
  const [movingAnswer, setMoving] = useState(false);
  const { append, remove, applyWhere, setState: setAnswers } = handlers;
  const isEmpty = answers.length === 0;

  const insertQuestion = async (isAdditionalAnswer?: boolean) => {
    setInserting(true);
    const resJSON = await QuestionBundleS.insertAnswer(questionId, language, isAdditionalAnswer);
    setInserting(false);
    if (resJSON) {
      if (!isAdditionalAnswer) {
        append(resJSON);
      } else {
        setAdditionalAnswer(resJSON);
      }
    }
  };

  const moveAnswer = async (answerId: string, targetAnswerId: string) => {
    setMoving(true);
    const resJSON = await QuestionBundleS.moveAnswer(questionId, answerId, targetAnswerId);
    setMoving(false);
    if (resJSON) {
      setAnswers(resJSON);
    }
  };

  const handleChange = (answerId: string, patch: Partial<AnswerDto>) =>
    applyWhere(
      (item) => item.id === answerId,
      (item) => ({ ...item, ...patch }),
    );

  return (
    <>
      <ThemeText size="md" weight="bolder" mb="sm" mt="xl">
        Antworten
        {/* {answers.length > 0 && (
          <Text mt={5} color="dimmed" size="xs" weight="normal">
            Tipp: Verwenden Sie Bilder mit Antworten und vereinfachen Sie den Entscheidungsprozess für Ihren Kunden
          </Text>
        )} */}
      </ThemeText>
      <Box pos="relative">
        {isEmpty && <EmptyText mb={-5} />}
        <LoadingOverlay visible={movingAnswer} overlayBlur={2} loaderProps={{ size: 'xl' }} />
        <Stack spacing="xs" mt="md">
          {answers.map((a, index) => (
            <AnswerOptionItem
              key={a.id}
              questionId={questionId}
              answer={a}
              handleChange={(patch) => handleChange(a.id, patch)}
              moveAnswer={moveAnswer}
              onDelete={() => remove(index)}
            />
          ))}
          {additionalAnswer && (
            <AnswerOptionItem
              isAdditional
              questionId={questionId}
              answer={additionalAnswer}
              handleChange={() => null}
              onDelete={() => setAdditionalAnswer(null)}
            />
          )}
          {inserting && <Skeleton height={50} />}
        </Stack>
        {!inserting && (
          <Group mt="sm">
            <LinkText onClick={() => insertQuestion()}>{i18n._('common.add.answer')}</LinkText>
            {!additionalAnswer && (
              <LinkText onClick={() => insertQuestion(true)}>{i18n._('common.add.answer.additional')}</LinkText>
            )}
          </Group>
        )}
      </Box>
    </>
  );
};

export default QuestionAnswers;
